import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./BlogDetails.css";

function BlogDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const IMAGE_URL = "https://aethearia.store/superadmin/uploads/blogs/";

  const fetchBlogDetail = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `https://aethearia.store/superadmin/api/blogDetail/${slug}`
      );

      const data = await res.json();

      console.log("Blog Detail:", data);

      if (data.status) {
        setBlog(data.data);
      } else {
        setBlog(null);
      }
    } catch (error) {
      console.log("Blog detail error:", error);
      setBlog(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchRecentBlogs = async () => {
    try {
      const res = await fetch(
        "https://aethearia.store/superadmin/api/blogList"
      );

      const data = await res.json();

      console.log("Recent Blogs:", data);

      if (data.status) {
        setRecentBlogs(data.data || []);
      }
    } catch (error) {
      console.log("Recent blog error:", error);
    }
  };

  useEffect(() => {
    fetchBlogDetail();
    fetchRecentBlogs();
  }, [slug]);

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getParagraphs = (text) => {
    if (!text) return [];

    return text
      .split(/\r?\n\r?\n/)
      .map((item) => item.trim())
      .filter(Boolean);
  };

  if (loading) {
    return (
      <>
        <Header />
        <main className="blog-detail-page">
          <div className="blog-loading">Loading blog...</div>
        </main>
        <Footer />
      </>
    );
  }

  if (!blog) {
    return (
      <>
        <Header />
        <main className="blog-detail-page">
          <div className="blog-not-found">
            <h2>Blog not found</h2>
            <p>The blog you are looking for is not available.</p>
            <button onClick={() => navigate("/blogs")}>Back to Blogs</button>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <main className="blog-detail-page">
        <div className="blog-detail-wrapper">
          <section className="blog-detail-main">
            <h1>{blog.blogtitle}</h1>

            <div className="blog-detail-meta">
              <span>Blog</span>
              <span>|</span>
              <span>{formatDate(blog.blogdate)}</span>
            </div>

            <div className="blog-detail-image">
              <img
                src={`${IMAGE_URL}${blog.image}`}
                alt={blog.blogtitle}
                onError={(e) => {
                  e.currentTarget.src = "/blogs/default-blog.jpg";
                }}
              />
            </div>

            {blog.short_desc && (
              <p className="blog-short-desc">{blog.short_desc}</p>
            )}

            <div className="blog-description">
              {getParagraphs(blog.blogdesc).map((para, index) => (
                <p key={index}>{para}</p>
              ))}
            </div>
          </section>

          <aside className="blog-sidebar">
            <h3>Recent Post</h3>

            <div className="recent-post-list">
              {recentBlogs
                .filter((item) => item.slug !== slug)
                .slice(0, 6)
                .map((item) => (
                  <Link
                    to={`/blogs/${item.slug}`}
                    className="recent-post-card"
                    key={item.id}
                  >
                    <img
                      src={`${IMAGE_URL}${item.image}`}
                      alt={item.blogtitle}
                      onError={(e) => {
                        e.currentTarget.src = "/blogs/default-blog.jpg";
                      }}
                    />

                    <div>
                      <h4>{item.blogtitle}</h4>
                      <p>
                        Posted On : {formatDate(item.blogdate)}
                      </p>
                    </div>
                  </Link>
                ))}

              {recentBlogs.filter((item) => item.slug !== slug).length === 0 && (
                <p className="no-recent-post">No recent posts available.</p>
              )}
            </div>
          </aside>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default BlogDetails;